/*eslint-disable*/
import React, { useEffect, useState, } from "react";
import db from "../../db"
import { currentUser } from "../../fb"

// reactstrap components

// core components
import Events from "../../components/Portfolio/Index/Events"
import ColorNavbar from "../../components/Navbars/ColorNavbar";
import { LoadingScreen, } from "../../components/MiscFunctions"

function AdminEvents() {
    document.documentElement.classList.remove("nav-open");

    const [events, setEvents] = useState([])
    useEffect(() => db.Events.listenAll(setEvents), [])

    return (
        <div className="fullBg section-dark">
            {
                !events || events && events.length > 0 || true ?
                    <>
                        <ColorNavbar changing={false} />
                        <Events admin={true} size="4" events={events} />
                    </>
                    :
                    <LoadingScreen />
            }
        </div>
    );
}

export default AdminEvents;
